import { render, staticRenderFns } from "./PatientDetailView.vue?vue&type=template&id=64d7b9d1&scoped=true"
import script from "./PatientDetailView.vue?vue&type=script&lang=js"
export * from "./PatientDetailView.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailView.vue?vue&type=style&index=0&id=64d7b9d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7b9d1",
  null
  
)

export default component.exports